import { useMutation } from "@tanstack/react-query";
import { post } from "../../api/util";

export function useGenberegnEfteruddannelsePeriodeMutation<OperationError>(
  personId: string,
  invalidateData: () => void,
) {
  const mutation = useMutation<unknown, OperationError>({
    onSuccess: () => {
      invalidateData();
    },
    onError: () => {
      setTimeout(() => {
        mutation.reset();
      }, 10000);
    },
    mutationFn: () => {
      return post({
        query: `person/${personId}/efteruddannelser`,
      });
    },
  });
  return mutation;
}
